import React, { useState, useCallback, useEffect, forwardRef } from "react";
import { FormLayout, TextField, Text, Select } from "@shopify/polaris";

const PositioningStyle = (props) => {
  const handleChangeOffsetTop = (newValue) => {
    props.handleChangeOffsetTop(newValue);
  };
  const handleChangeOffsetBottom = (newValue) => {
    props.handleChangeOffsetBottom(newValue);
  };
  const handleChangeOffsetLeft = (newValue) => {
    props.handleChangeOffsetLeft(newValue);
  };
  const handleChangeOffsetRight = (newValue) => {
    props.handleChangeOffsetRight(newValue);
  };
  const handleChangeOffsetTopMobile = (newValue) => {
    props.handleChangeOffsetTopMobile(newValue);
  };
  const handleChangeOffsetBottomMobile = (newValue) => {
    props.handleChangeOffsetBottomMobile(newValue);
  };
  const handleChangeOffsetLeftMobile = (newValue) => {
    props.handleChangeOffsetLeftMobile(newValue);
  };
  const handleChangeOffsetRightMobile = (newValue) => {
    props.handleChangeOffsetRightMobile(newValue);
  };
  const handleSelectChangePosition = (newValue) => {
    props.handleSelectChangePosition(newValue);
  };
  const handleChangeZindex = (newValue) => {
    props.handleChangeZindex(newValue);
  };
  const handleChangeZindexMobile = (newValue) => {
    props.handleChangeZindexMobile(newValue);
  };
  const handleSelectChangePositionMobile = (newValue) => {
    props.handleSelectChangePositionMobile(newValue);
  };
  const optionsPositions = [
    { label: "Relative", value: "relative" },
    { label: "Absolute", value: "absolute" },
    { label: "Fixed", value: "fixed" },
    { label: "Static", value: "static" },
  ];
  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        POSITIONING
      </Text>
      <FormLayout.Group condensed>
        <FormLayout>
          <Text variant="headingXs" as="h6">
            DESKTOP
          </Text>
          <Select
            label="Position"
            options={optionsPositions}
            onChange={handleSelectChangePosition}
            value={
              props?.item?.positioning?.position?.desktop
                ? props?.item?.positioning?.position?.desktop
                : ""
            }
            placeholder="Please select"
          />
          <TextField
            label="Offset Top"
            value={
              props?.item?.positioning?.offset?.top?.desktop
                ? props?.item?.positioning?.offset?.top?.desktop
                : ""
            }
            onChange={handleChangeOffsetTop}
            type="number"
          />
          <TextField
            label="Offset Bottom"
            value={
              props?.item?.positioning?.offset?.bottom?.desktop
                ? props?.item?.positioning?.offset?.bottom?.desktop
                : ""
            }
            onChange={handleChangeOffsetBottom}
            type="number"
          />
          <TextField
            label="Offset Left"
            value={
              props?.item?.positioning?.offset?.left?.desktop
                ? props?.item?.positioning?.offset?.left?.desktop
                : ""
            }
            onChange={handleChangeOffsetLeft}
            type="number"
          />
          <TextField
            label="Offset Right"
            value={
              props?.item?.positioning?.offset?.right?.desktop
                ? props?.item?.positioning?.offset?.right?.desktop
                : ""
            }
            onChange={handleChangeOffsetRight}
            type="number"
          />
          <TextField
            label="Z Index"
            value={
              props?.item?.positioning?.zIndex?.desktop
                ? props?.item?.positioning?.zIndex?.desktop
                : ""
            }
            onChange={handleChangeZindex}
            type="number"
          />
        </FormLayout>
        <FormLayout>
          <Text variant="headingXs" as="h6">
            MOBILE
          </Text>
          <Select
            label="Position"
            options={optionsPositions}
            onChange={handleSelectChangePositionMobile}
            value={
              props?.item?.positioning?.position?.mobile
                ? props?.item?.positioning?.position?.mobile
                : ""
            }
            placeholder="Please select"
          />
          <TextField
            label="Offset Top"
            value={
              props?.item?.positioning?.offset?.top?.mobile
                ? props?.item?.positioning?.offset?.top?.mobile
                : ""
            }
            onChange={handleChangeOffsetTopMobile}
            type="number"
          />
          <TextField
            label="Offset Bottom"
            value={
              props?.item?.positioning?.offset?.bottom?.mobile
                ? props?.item?.positioning?.offset?.bottom?.mobile
                : ""
            }
            onChange={handleChangeOffsetBottomMobile}
            type="number"
          />
          <TextField
            label="Offset Left"
            value={
              props?.item?.positioning?.offset?.left?.mobile
                ? props?.item?.positioning?.offset?.left?.mobile
                : ""
            }
            onChange={handleChangeOffsetLeftMobile}
            type="number"
          />
          <TextField
            label="Offset Right"
            value={
              props?.item?.positioning?.offset?.right?.mobile
                ? props?.item?.positioning?.offset?.right?.mobile
                : ""
            }
            onChange={handleChangeOffsetRightMobile}
            type="number"
          />
          <TextField
            label="Z Index"
            value={
              props?.item?.positioning?.zIndex?.mobile
                ? props?.item?.positioning?.zIndex?.mobile
                : ""
            }
            onChange={handleChangeZindexMobile}
            type="number"
          />
        </FormLayout>
      </FormLayout.Group>
    </FormLayout>
  );
};

export default PositioningStyle;
